(() => {
  if (window.lemonMegaMenuLoaded) return;
  window.lemonMegaMenuLoaded = true;
  function init(root) {
    root.querySelectorAll('[data-lemon-mega]').forEach(nav => {
      if (nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      const items = Array.from(nav.querySelectorAll('.lm-item'));
      let active = null, hoverOpened = null, timer;
      function close(focus = false) {
        clearTimeout(timer);
        if (!active) return;
        const item = active;
        item.querySelector('.lm-trigger').setAttribute('aria-expanded', 'false');
        item.querySelector('.lm-panel').hidden = true;
        active = null;
        hoverOpened = null;
        if (focus) item.querySelector('.lm-trigger').focus();
      }
      function open(item) {
        clearTimeout(timer);
        if (active !== item) close();
        active = item;
        item.querySelector('.lm-trigger').setAttribute('aria-expanded', 'true');
        item.querySelector('.lm-panel').hidden = false;
      }
      items.forEach((item, index) => {
        const trigger = item.querySelector('.lm-trigger');
        trigger.addEventListener('click', () => { if (hoverOpened === item) { hoverOpened = null; open(item); } else { active === item ? close() : open(item); } });
        item.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse' && active !== item) { open(item); hoverOpened = item; } });
        item.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') timer = setTimeout(() => { if (!item.contains(document.activeElement)) close(); }, 180); });
        item.querySelector('.lm-close').addEventListener('click', () => close(true));
        trigger.addEventListener('keydown', e => {
          if (e.key === 'ArrowDown') { e.preventDefault(); open(item); item.querySelector('.lm-panel a, .lm-close')?.focus(); }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); close(); items[(index + (e.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length].querySelector('.lm-trigger').focus(); }
        });
      });
      nav.addEventListener('keydown', e => { if (e.key === 'Escape' && active) { e.preventDefault(); close(true); } });
      nav.addEventListener('focusout', e => { if (!nav.contains(e.relatedTarget)) close(); });
      document.addEventListener('click', e => { if (!nav.contains(e.target)) close(); });
      document.addEventListener('shopify:block:select', e => {
        const block = e.target.closest('.lm-item');
        if (block && nav.contains(block)) open(block);
      });
      window.addEventListener('resize', () => close());
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
